module.exports = __webpack_public_path__ + "img/Mask Group 8.3981e35f.png";